<template>
  <div id="mb-quiz-with-border" class="mb-quiz-with-border" @click="cancelCheck()">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setMainImageValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setMainImageValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setMainImageValue(startGameConfig.mainImage.pos.y, 0) + 'px',
        left: setMainImageValue(startGameConfig.mainImage.pos.x, 0) + 'px',
      }"
    />
    <div
      v-for="(staticText, indexSt) in startGameConfig.staticText"
      :key="'mb-quiz-with-border-static-text-' + indexSt"
      :style="setStaticTextStyle(staticText)"
    >
      <ps-text
        :style="staticText.textStyle"
        :font-size="staticText.fontSize ? staticText.fontSize : null"
        :text-value="`${staticText.text}`"
      ></ps-text>
    </div>
    <!-- <div v-if="gameState" class="curtain" @click="cancelCheck()"></div> -->
    <div class="mb-quiz-with-border-question" v-if="question" :style="[setQuestionStyle(question)]">
      <img v-if="question.img" :src="giveMeImagePlease(question.img.src)" />
    </div>
    <div class="mb-quiz-with-border-answers" :style="borderAnswerSetStyle(question)">
      <div
        class="mb-quiz-with-border-answer"
        v-for="(it, index) in items"
        :key="'mb-quiz-with-border-answer-' + index"
        :style="quizAnswerStyle(it.width, it.height, it.pos)"
      >
        <!-- <div class="img-border"> -->
        <img
          draggable="false"
          v-if="it.img"
          :src="giveMeImagePlease(it.img.src)"
          @click="setState(index)"
          :style="setImgMainStyle(it.width, it.height, it.state, checkImg, correctImg, inorrectImg)"
        />
        <div
          style="transition: 0.5s; align-items: center; justify-content: center; display: flex; background: white"
          v-if="it.text"
          @click="setState(index)"
          :style="[
            setTextStyle(it.width, it.height, it.state, checkImg, correctImg, inorrectImg),
            { fontSize: isKatexFontSize ? isKatexFontSize : `${fontSize}px` },
          ]"
        >
          <ps-text
            :style="it.textStyle"
            :font-size="isKatexFontSize ? isKatexFontSize : null"
            :text-value="`${it.text}`"
          ></ps-text>
        </div>
        <!-- </div> -->
        <div
          v-if="startGameConfig.checkbox"
          style="
            width: 60px;
            height: 60px;
            background: #f2f2f2;
            position: absolute;
            left: calc(50% - 30px);
            bottom: -35px;
            cursor: pointer;
            box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3);
          "
        >
          <div
            @click="setState(index)"
            style="width: 46px; height: 46px; transition: 0.5s; margin: 7px; opacity: 0.8"
            :style="imgSetColor(it.state)"
          ></div>
        </div>
        <transition name="img-check-fade">
          <img
            draggable="false"
            v-if="it.state == 'check' && checkImg"
            :src="giveMeImagePlease(checkImg)"
            style="cursor: auto"
            :style="imgSetStyle(it.width, it.height)"
          />
        </transition>
        <transition name="img-fade">
          <img
            draggable="false"
            v-if="it.state == 'correct' && correctImg"
            :src="giveMeImagePlease(correctImg)"
            style="cursor: auto"
            :style="imgSetStyle(it.width, it.height)"
          />
        </transition>
        <transition name="img-fade">
          <img
            draggable="false"
            v-if="it.state == 'incorrect' && inorrectImg"
            :src="giveMeImagePlease(inorrectImg)"
            @click="setState(index)"
            :style="imgSetStyle(it.width, it.height)"
          />
        </transition>
      </div>
    </div>
    <div></div>
  </div>
</template>
<script>
import defaultMixin from '../../mixins/defaultMixin';
import PsText from '../TrInput/PsText';
import _ from 'lodash';
import { Howler } from 'howler';
export default {
  name: 'mb-quiz-with-border',
  components: { PsText },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      katexFontSize: this.startGameConfig.katexFontSize,
      fontSize: this.startGameConfig.fontSize || 26,
      numberOfVerticalItems: 1,
      numberOfHorizontalItems: 1,
      question: '',
      items: [],
      checkImg: null,
      correctImg: null,
      inorrectImg: null,
      canIClick: true,
      gameState: false,
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    setStaticTextStyle(st) {
      let style = {};
      style.position = 'absolute';
      style.height = st.height + 'px';
      style.width = st.width + 'px';
      style.top = st.pos.y + 'px';
      style.left = st.pos.x + 'px';
      return style;
    },
    borderAnswerSetStyle(question) {
      let style = {};
      if (question && !this.startGameConfig.itemsPos) {
        style.height = '30%';
      } else {
        style.height = '100%';
        style.display = 'block';
        style.position = 'absolute';
        style.top = 0;
      }
      if (
        this.startGameConfig.numberOfVerticalItems &&
        this.startGameConfig.numberOfHorizontalItems &&
        this.startGameConfig.grid
      ) {
        style.display = 'grid';
        style.gridRowGap = '20px';
        style.gridColumnGap = '20px';
        style.gridTemplateColumns =
          'repeat(' +
          this.startGameConfig.numberOfHorizontalItems +
          ', calc(' +
          100 / this.startGameConfig.numberOfHorizontalItems +
          '% - 20px))';
        style.gridTemplateRows =
          'repeat(' +
          this.startGameConfig.numberOfVerticalItems +
          ', calc(' +
          100 / this.startGameConfig.numberOfVerticalItems +
          '% - 20px))';
      }
      if (!question && this.startGameConfig.answerBox) {
        style.height = this.startGameConfig.answerBox.height + '%';
        style.width = this.startGameConfig.answerBox.width + '%';
        style.top = (100 - this.startGameConfig.answerBox.height) / 2 + '%';
        style.left = (100 - this.startGameConfig.answerBox.width) / 2 + '%';
        if (this.startGameConfig.answerBox.top) {
          style.top = this.startGameConfig.answerBox.top + '%';
        }
        if (this.startGameConfig.answerBox.left) {
          style.left = this.startGameConfig.answerBox.left + '%';
        }
      }
      // console.log(style);
      return style;
    },
    quizAnswerStyle(width, height, pos) {
      let style = {};
      if (width && height) {
        style.width = width + 40 + 'px';
        style.height = height + 40 + 'px';
        style.position = 'absolute';
      } else {
        style.maxWidth = 'calc(100% + 40px)';
        style.maxHeight = 'calc(100% + 40px)';
      }
      if (
        this.startGameConfig.numberOfVerticalItems &&
        this.startGameConfig.numberOfHorizontalItems &&
        this.startGameConfig.grid
      ) {
        style.position = 'relative';
      }
      if (pos) {
        style.top = pos.y + 'px';
        style.left = pos.x + 'px';
      } else {
        style.maxWidth = 'calc(100% + 40px)';
        style.maxHeight = 'calc(100% + 40px)';
      }
      return style;
    },
    setImgMainStyle(width, height, state, checkImg, correctImg, inorrectImg) {
      let style = {};
      if (width && height) {
        style.borderRadius = '10px';
      }
      if (this.startGameConfig.checkbox) {
        style.maxHeight = 'calc(100%)';
      }
      if (state == 'check' && !checkImg) {
        style.boxShadow = '0 0 0 8px #0aabff,0 0 0 2px #0aabff, 0 0 0 16px #ffffff';
        style.borderRadius = '10px';
      } else if (state == 'correct' && !correctImg) {
        style.boxShadow = '0 0 0 8px #00d60b,0 0 0 2px #0aabff, 0 0 0 16px #ffffff';
        style.borderRadius = '10px';
      } else if (state == 'incorrect' && !inorrectImg) {
        style.boxShadow = '0 0 0 8px #fe0a02,0 0 0 2px #0aabff, 0 0 0 16px #ffffff';
        style.borderRadius = '10px';
      } else {
        if (this.startGameConfig.noBlueBorder) {
          style.boxShadow = '0 0 0 0px transparent,0 0 0 2px white, 0 0 0 16px #ffffff';
          style.borderRadius = '10px';
        } else {
          style.boxShadow = '0 0 0 0px transparent,0 0 0 2px #0aabff, 0 0 0 16px #ffffff';
          style.borderRadius = '10px';
        }
      }
      if (!this.startGameConfig.noShadow) {
        if (style.boxShadow) {
          style.boxShadow = style.boxShadow + ', 0 0 4px 16px rgba(0, 0, 0, 0.3)';
        }
      }
      if (this.startGameConfig.grid) {
        style.maxHeight = 'calc(100%)';
        style.maxWidth = 'calc(100%)';
      }
      return style;
    },
    setTextStyle(width, height, state, checkImg, correctImg, inorrectImg) {
      let style = {};
      if (width && height) {
        style.width = width + 'px';
        style.height = height + 'px';
        style.borderRadius = '10px';
      } else {
        style.width = '100%';
        style.height = '100%';
      }

      if (this.startGameConfig.checkbox) {
        style.maxHeight = 'calc(100%)';
      }
      if (state == 'check' && !checkImg) {
        style.boxShadow = '0 0 0 8px #0aabff,0 0 0 2px #0aabff, 0 0 0 16px #ffffff';
        style.borderRadius = '10px';
      } else if (state == 'correct' && !correctImg) {
        style.boxShadow = '0 0 0 8px #00d60b,0 0 0 2px #0aabff, 0 0 0 16px #ffffff';
        style.borderRadius = '10px';
      } else if (state == 'incorrect' && !inorrectImg) {
        style.boxShadow = '0 0 0 8px #fe0a02,0 0 0 2px #0aabff, 0 0 0 16px #ffffff';
        style.borderRadius = '10px';
      } else {
        if (this.startGameConfig.noBlueBorder) {
          style.boxShadow = '0 0 0 0px transparent,0 0 0 2px white, 0 0 0 16px #ffffff';
          style.borderRadius = '10px';
        } else {
          style.boxShadow = '0 0 0 0px transparent,0 0 0 2px #0aabff, 0 0 0 16px #ffffff';
          style.borderRadius = '10px';
        }
      }
      if (!this.startGameConfig.noShadow) {
        if (style.boxShadow) {
          style.boxShadow = style.boxShadow + ', 0 0 4px 16px rgba(0, 0, 0, 0.3)';
        }
      }
      if (this.startGameConfig.grid) {
        style.maxHeight = 'calc(100%)';
        style.maxWidth = 'calc(100%)';
      }
      return style;
    },
    imgSetColor(state) {
      if (state == 'check') {
        return {
          background: '#0aabff',
        };
      } else if (state == 'correct') {
        return {
          background: '#00d60b',
        };
      } else if (state == 'incorrect') {
        return {
          background: '#fe0a02',
        };
      } else {
        return {};
      }
    },
    imgSetStyle(width, height) {
      if (width && height) {
        return { 'max-width': 'calc(100%)', 'max-height': 'calc(100%)' };
      } else {
        return { 'max-width': 'calc(100% - 40px)', 'max-height': 'calc(100% - 40px)' };
      }
    },
    setGrid(number) {
      let value = '';
      for (let i = 0; i < number; i++) {
        value = value + 100 / number + '% ';
      }
      return value;
    },
    setQuestionStyle(question) {
      let style;
      if (question) {
        if (question.width && question.height) {
          style = { width: question.width + 'px', height: question.height + 'px', position: 'absolute', padding: 0 };
          if (question.pos) {
            style.top = question.pos.y + 'px';
            style.left = question.pos.x + 'px';
          }
        }
        return style;
      }
    },
    setAnswerDimensions(w, h) {
      if (w && h) {
        return { width: w + 'px', height: h + 'px' };
      }
    },
    setAnswerPos(pos) {
      if (pos) {
        return { position: 'absolute', top: pos.y + 'px', left: pos.x + 'px' };
      }
    },
    setMainImageValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    checkGameCorrect() {
      let value = true;
      this.items.forEach((it) => {
        if (it.state == 'correct') {
          if (!it.correct) value = false;
        }
        if (it.state == 'incorrect') value = false;
        if (it.correct) {
          if (it.state != 'correct') value = false;
        }
      });
      this.gameState = value;
      console.log(value);
      if (this.gameState) {
        this.canIClick = false;
        this.$store.dispatch('checkGame');
      } else {
        this.canIClick = true;
      }
    },
    setValue(items, id, it) {
      this.$set(items, id, it);
    },
    setState(id) {
      let it = this.items[id];
      if (it.state != 'correct') {
        if (this.canIClick) {
          this.canIClick = false;
          if (this.$store.getters.gameCheckSwitch) this.$store.commit('CHANGE_CHECK_SWITCH', false);
          if (it.state) it.state = null;
          else it.state = 'check';
          this.setValue(this.items, id, it);
          if (!this.startGameConfig.noAutoCheck) {
            if (it.state == 'check') {
              setTimeout(() => {
                if (it.correct) {
                  it.state = 'correct';
                  this.setValue(this.items, id, it);
                  this.checkGameCorrect();
                } else {
                  it.state = 'incorrect';
                  this.canIClick = true;
                  this.setValue(this.items, id, it);
                }
              }, 1000);
            } else {
              this.canIClick = true;
              this.checkGameCorrect();
            }
          } else {
            this.canIClick = true;
          }
        }
      }
    },
    init() {
      this.numberOfVerticalItems = _.cloneDeep(this.startGameConfig.numberOfVerticalItems);
      this.numberOfHorizontalItems = _.cloneDeep(this.startGameConfig.numberOfHorizontalItems);
      this.question = _.cloneDeep(this.startGameConfig.question);
      if (this.startGameConfig.groups) {
        this.startGameConfig.shuffle = false;
        this.startGameConfig.pick = false;
        let tmpArray = [];
        let tmpGroups = _.cloneDeep(this.startGameConfig.groups);
        if (this.startGameConfig.groupsShuffle) tmpGroups = this.shuffle(tmpGroups);
        for (let i = 0; i < tmpGroups.length; i++) {
          tmpGroups[i] = this.shuffle(tmpGroups[i]);
          tmpGroups[i].forEach((it) => {
            tmpArray.push(it);
          });
        }
        this.startGameConfig.items = tmpArray;
      }
      if (this.startGameConfig.pick) {
        let tmpArray;
        tmpArray = _.cloneDeep(this.startGameConfig.items);
        let tmpArrayIsAlways = [];
        let tmpArrayAdditional = [];
        tmpArray.forEach((el) => {
          if (el.isAlways) tmpArrayIsAlways.push(el);
          else tmpArrayAdditional.push(el);
        });
        tmpArray = tmpArrayIsAlways;
        tmpArrayAdditional = this.shuffle(tmpArrayAdditional);
        tmpArray = tmpArray.concat(tmpArrayAdditional.slice(0, this.startGameConfig.pick - tmpArray.length));
        this.items = _.cloneDeep(this.shuffle(tmpArray));
      } else {
        this.items = _.cloneDeep(this.startGameConfig.items);
        if (this.startGameConfig.shuffle) this.items = this.shuffle(this.items);
      }
      if (this.startGameConfig.itemsPos) {
        let posIndex = 0;
        this.items.forEach((el) => {
          if (!el.pos) {
            el.pos = this.startGameConfig.itemsPos[posIndex];
            posIndex++;
          }
        });
      }
      this.checkImg = _.cloneDeep(this.startGameConfig.checkImg);
      this.correctImg = _.cloneDeep(this.startGameConfig.correctImg);
      this.inorrectImg = _.cloneDeep(this.startGameConfig.incorrectImg);
    },
    setAnswerStyle() {
      return this.question
        ? { display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'center' }
        : {
            width: 90 / this.numberOfHorizontalItems + '%',
            height: 90 / this.numberOfVerticalItems + '%',
            display: 'inline-block',
          };
    },
    cancelCheck() {
      if (this.$store.getters.gameCheckSwitch && this.canIClick) this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    checkGameAction() {
      console.log('CHECK');
      if (this.startGameConfig.noAutoCheck) {
        this.items.forEach((it, id) => {
          if (it.state == 'check') {
            if (it.correct) {
              it.state = 'correct';
              this.setValue(this.items, id, it);
            } else {
              it.state = 'incorrect';
              // this.canIClick = true;
              this.setValue(this.items, id, it);
            }
          }
        });
        // this.compKey++;
        this.checkGameCorrect();
      }
      return this.gameState;
    },
    resetGameAction() {
      this.numberOfVerticalItems = 1;
      this.numberOfHorizontalItems = 1;
      this.question = '';
      this.items = [];
      this.checkImg = null;
      this.correctImg = null;
      this.inorrectImg = null;
      this.canIClick = true;
      this.gameState = false;
      this.init();
    },

    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  beforeDestroy() {},
  computed: {
    isKatexFontSize() {
      if (this.katexFontSize) {
        return this.katexFontSize;
      } else {
        return false;
      }
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.curtain
  position: absolute
  top: 0
  width: 1920px
  height: 1080px
  left: 0
  z-index: 2
.mb-quiz-with-border
  background-size: contain
  background-repeat: no-repeat
  position: relative
  left: $backgroundOffsetLeft
  overflow: hidden
  height: 100%
  width: 100%
  top: 0px
  .mb-quiz-with-border-question
    width: 100%
    padding: 50px
    height: 70%
    display: flex
    align-items: center
    flex-direction: column
    justify-content: center
    img
      z-index: 2
      max-width: 100%
      max-height: 100%
  .mb-quiz-with-border-answers
    width: 100%
    height: 30%
    display: flex
    align-items: center
    flex-direction: row
    justify-content: space-evenly
    .mb-quiz-with-border-answer
      padding: 20px
      height: 100%
      // background-color: white
      position: relative
      img
        transition: .5s
        position: relative
        cursor: pointer
        margin: auto

.img-fade-leave-active, .img-fade-enter-active
  transition: all .5s linear
.img-fade-leave-to, .img-fade-enter
  opacity: 0
.img-check-fade-leave-active
  transition: all .1s .5s linear
.img-check-fade-enter-active
  transition: all .3s linear
.img-check-fade-leave-to, .img-check-fade-enter
  opacity: 0
</style>
